"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "CredentialCache", {
    enumerable: true,
    get: function() {
        return CredentialCache;
    }
});
const _identity = require("@azure/identity");
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
const CREDENTIAL_FACTORY = {
    environment: ()=>new _identity.EnvironmentCredential(),
    "workload-identity": ()=>new _identity.WorkloadIdentityCredential(),
    "managed-identity": ()=>new _identity.ManagedIdentityCredential(),
    "visual-studio-code": ()=>new _identity.VisualStudioCodeCredential(),
    "azure-cli": ()=>new _identity.AzureCliCredential()
};
class CredentialCache {
    /**
   * Returns a credential instance based on the provided name. Results are cached per name.
   * If no name is provided, EnvironmentCredential is used by default.
   */ static getInstance(credentialName) {
        const key = credentialName ?? "environment";
        const existing = this.cache.get(key);
        if (existing) return existing;
        const credential = CREDENTIAL_FACTORY[key]();
        this.cache.set(key, credential);
        return credential;
    }
}
_define_property(CredentialCache, "cache", new Map());
// Expose the list for runtime validation elsewhere (derived from the exhaustive factory above)
_define_property(CredentialCache, "credentialNames", Object.keys(CREDENTIAL_FACTORY));
